import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import ItemList from '../ItemList/ItemList'; // ✅ Mantiene el mismo componente de listado
import "../ItemListContainer/style.css";

const diasSemana = ['Gorras', 'Gorros', 'Chombas', 'Remeras'];

const ItemsListContainer = () => {
  const [viandas, setViandas] = useState([]);
  const { id } = useParams();

  useEffect(() => {
    axios.get('https://pedir-imperfctt.p89nps.easypanel.host/api/viandas')
      .then(response => {
        setViandas(response.data);
        console.log("DATOS OBTENIDOS", response.data);
      })
      .catch(error => {
        console.error('Error fetching data:', error);
      });
  }, []);

  // **Agrupar viandas por día**
  const viandasPorDia = diasSemana.reduce((acc, dia) => {
    acc[dia] = viandas.filter(vianda => vianda.dia_semana === dia);
    return acc;
  }, {});

  return (
    <Container className="fondo">
      <h2 className="titulo-combos text-center my-4">Productos por categoria</h2>

      {diasSemana.map((dia) => (
        <div key={dia} className="mb-4">
          <h3 
   id={`dia-${dia}`}
  className="text-center banner-dia" 
  style={{
    backgroundColor: "#c17c67",          // Terracota suave (acento principal)
    color: "#ffffff",                    // Texto blanco para contraste
    width: "100%",
    padding: "10px 0",
    borderRadius: "5px",
    fontWeight: "bold",
    boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)",
    letterSpacing: "1px",               // Opcional: le da un look más moderno
    textAlign: "center"                 // Por si querés centrar el texto
  }}
  
>
  {dia}
</h3>

          <Row className="gx-4 gy-4 d-flex justify-content-center">
            {viandasPorDia[dia]?.length > 0 ? (
              viandasPorDia[dia].slice(0, 6).map((vianda) => ( // ✅ Máximo 3 viandas por día
                <Col key={vianda.id} xs={12} sm={6} md={4} lg={4}> {/* ✅ Distribuye en 3 columnas */}
                  <ItemList item={[vianda]} /> {/* ✅ Mantiene el mismo componente de listado */}
                </Col>
              ))
            ) : (
              <Col xs={12}>
                <p className="text-center text-muted">Proximamente</p>
              </Col>
            )}
          </Row>
        </div>
      ))}
    </Container>
  );
};

export default ItemsListContainer;
